import Icon from '../components/Icon.vue'

Icon.register({"life-ring":{"width":512,"height":512,"paths":[{"d":"M256 8C119 8 8 119 8 256S119 504 256 504 504 393 504 256 393 8 256 8zM429.7 127.6L366.3 191C355.3 172.4 339.6 156.7 321 145.7L384.4 82.3A218.4-218.4 0 0 0 429.7 127.6zM256 352C203 352 160 309 160 256S203 160 256 160 352 203 352 256 309 352 256 352zM127.6 82.3L191 145.7C172.4 156.7 156.7 172.4 145.7 191L82.3 127.6A218.4-218.4 0 0 0 127.6 82.3zM82.3 384.4L145.7 321C156.7 339.6 172.4 355.3 191 366.3L127.6 429.7A218.4-218.4 0 0 0 82.3 384.4zM384.4 429.7L321 366.3C339.6 355.3 355.3 339.6 366.3 321L429.7 384.4A218.4-218.4 0 0 0 384.4 429.7z"}]}})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/life-ring.js
// module id = or/X
// module chunks = 0